<template>
  <el-form ref="form" inline>
    <el-form-item label="客户名称" required>
      <customer-auto-complete :value.sync="autoComplete.supplier"
                              :default-value="defaultCustomer"
                              @clear="clearSupplier"
                              @setValue="setSupplier"/>
    </el-form-item>
    <el-form-item label="公司名称">
      <el-select :value="values.companyName" placeholder="请选择公司名称" @change="selectCompany">
        <el-option v-for="item in accountList"
                   :key="JSON.stringify(item)"
                   :label="item.accountName"
                   :value="JSON.stringify(item)"/>
      </el-select>
    </el-form-item>
    <el-form-item label="联系人">
      <el-select :value="values.contact" placeholder="请选择联系人" @change="selectContact">
        <el-option v-for="item in contactList"
                   :key="JSON.stringify(item)"
                   :label="item.contactName"
                   :value="JSON.stringify(item)"/>
      </el-select>
    </el-form-item>
    <el-form-item label="联系电话" required>
      <el-input v-model="customer.phoneNumber" disabled/>
    </el-form-item>
    <el-form-item label="注册地址">
      <el-input v-model="customer.regLocation"/>
    </el-form-item>
    <el-form-item label="开户银行" required>
      <el-select :value="values.bank" placeholder="请选择开户银行" @change="selectBank">
        <el-option v-for="item in bankInfoList"
                   :key="JSON.stringify(item)"
                   :label="item.openBank"
                   :value="JSON.stringify(item)"/>
      </el-select>
    </el-form-item>
    <el-form-item label="开户行账号" required>
      <el-input v-model="customer.bankAccount" disabled/>
    </el-form-item>
    <el-form-item label="邮编">
      <el-input v-model="customer.postcode"/>
    </el-form-item>
  </el-form>
</template>

<script>
/**
 * @Author: 菩萨蛮
 * @Date: 2020/9/3 5:16 下午
 * @Description: 用户form
 * @Version v1.0.0
 *
 * 本组件数据来源有两类，一种是查询所得，一种是客户本身数据
 * 公司的业务千篇一的代码好几百行。
 */


export default {
  name: 'CustomerForm',
  props: {
    cust: {
      type: Object,
      default: null
    },
    setDefault: { type: Boolean, default: false }
  },
  data() {
    return {
      customer: {
        companyName: '',
        contactName: '',
        phoneNumber: '',
        bank: '',
        bankAccount: '',
        postcode: '',
        regLocation: ''
      },
      defaultCustomer: undefined,
      autoComplete: {
        supplier: ''
      },
      values: {
        contact: '',
        supplierId: '',
        bank: ''
      },
      contactList: [],
      accountList: [],
      bankInfoList: [],
      isSetDefault: false
    };
  },
  created() {
    if (!this.utils.isEmpty(this.cust.companyName)) {
      this.setDefaultValue();
    }
  },
  watch: {
    cust: {
      deep: true,
      handler() {
        if (!this.utils.isEmpty(this.cust.companyName)) {
          this.setDefaultValue();
        }
      }
    },
    customer: {
      deep: true,
      handler() {
        if (JSON.stringify(this.cust) !== JSON.stringify((this.customer))) {
          this.$emit('update:cust', this.customer);
        }
      }
    }
  },
  methods: {
    selectCompany(item) {
      const company = JSON.parse(item);
      this.customer.companyName = company.accountName;
    },
    selectContact(item) {
      const contact = JSON.parse(item);
      this.values.contact = item;
      this.customer.contactName = contact.contactName;
      this.customer.phoneNumber = contact.phoneNumber;
      if (!this.utils.isEmpty(contact.postalCode)) {
        this.customer.postcode = contact.postalCode;
      }
    },
    /**
     * 设置默认值方法
     */
    async setDefaultValue() {
      const customer = this.utils.copy(this.customer);
      const { isEmpty, notEmptyArr } = this.utils;
      // 设置默认值

      // 公司名称
      customer.companyName = this.cust.companyName;
      customer.contactName = this.cust.contactName;
      this.defaultCustomer = this.cust.companyName;
      // 联系人 （选中联系人在下面）
      customer.phoneNumber = this.cust.phoneNumber;
      customer.regLocation = this.cust.regLocation;

      // 如果不是用户
      const { data } = await this.qGet(`customer/info?custName=${this.cust.companyName}`);
      const { datas } = data;
      if (this.utils.notEmptyArr(datas)) {
        const c = datas[0];
        // 设置初始值
        // 两个列表
        this.contactList = c.contactList;
        this.accountList = c.accountList;
        this.bankInfoList = c.bankInfoList;
      }

      const { phoneNumber, contactName } = this.cust;
      // 如果联系人和联系电话不为空
      if (!isEmpty(contactName) && !isEmpty(phoneNumber) && notEmptyArr(this.contactList)) {
        const contact = this.contactList
          .filter(e => e.contactName === contactName && e.phoneNumber === phoneNumber);
        if (contact.length > 0) {
          this.values.contact = JSON.stringify(contact[0]);
        }
      }

      // 开户银行选择
      const { bank, bankAccount } = this.cust;
      customer.bank = bank;
      customer.bankAccount = bankAccount;
      // 如果联系人和联系电话不为空
      if (!isEmpty(bank) && !isEmpty(bankAccount) && notEmptyArr(this.bankInfoList)) {
        const banks = this.bankInfoList
          .filter(e => e.openBank === bank && e.bankAccount === bankAccount);
        if (banks.length > 0) {
          this.values.bank = JSON.stringify(banks[0]);
        }
      }
      customer.postcode = this.cust.postcode;
      this.customer = {
        ...this.cust,
        ...customer
      };
    },
    /**
     * 选中客户后设置方法
     * @param item 客户信息
     */
    setSupplier(item) {
      const { notEmptyArr } = this.utils;
      if (notEmptyArr(item.contactList)) {
        this.contactList = item.contactList;
        this.accountList = item.accountList;
        const mainContact = item.contactList.filter(c => c.main)[0];
        this.values.contact = JSON.stringify(mainContact);
        this.customer.contactName = mainContact.contactName;
        this.customer.phoneNumber = mainContact.phoneNumber;
        this.customer.postcode = mainContact.postalCode;
      }
      if (notEmptyArr(item.bankInfoList)) {
        this.bankInfoList = item.bankInfoList;
      }
      if (notEmptyArr(item.addressList)) {
        this.addressList = item.addressList;
      }
      this.customer.regLocation = item.regLocation;
      this.customer.custId = item.id;
      this.values.supplierId = item.id;
      this.customer.companyName = item.custName || item.companyName;
      if (!this.utils.isEmpty(this.customer.companyName)) {
        this.defaultCustomer = this.customer.companyName;
      }
      this.values.bank = '';
      this.customer.bankAccount = '';
      this.customer.bank = '';
      this.customer.postcode = '';

      // 设置货币单位

      this.$emit('setDefaultCurrencyUnit', item.accountPeriodUnit);
    },
    selectBank(item) {
      const bank = JSON.parse(item);
      this.values.bank = item;
      this.customer.bank = bank.openBank;
      this.customer.bankAccount = bank.bankAccount;
      if (!this.utils.isEmpty(bank.regLocation)) {
        this.customer.regLocation = bank.regLocation;
      }

      this.$emit('setDefaultCurrencyUnit', bank.monetaryUnit);
    },
    clearSupplier() {
      this.autoComplete.supplier = '';
      this.values = {
        contact: '',
        supplierId: '',
        bank: ''
      };
      this.contactList = [];
      this.addressList = [];
      this.bankInfoList = [];
      this.customer.custId = '';
      this.customer.contactName = '';
      this.customer.phoneNumber = '';
      this.customer.bank = '';
      this.customer.bankAccount = '';
      this.customer.regLocation = '';
      this.customer.postcode = '';
      this.$emit('setDefaultCurrencyUnit', '');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
